import { getApiClient } from 'adapter/out/client/apiClient';
import LicensePermissions from 'domain/entity/LicensePermissions';

const getReadLicensePermissionsApiClient = getApiClient(() => `permissions`, LicensePermissions);

export default getReadLicensePermissionsApiClient;
